import { useSelector } from 'react-redux'
import { JsonLd } from 'react-schemaorg'

const StructuredSearchData = () => {
  const structuredSearchData = useSelector(
    (state) => state.items.structuredSearchData
  )

  return (
    <JsonLd
      item={{
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: structuredSearchData,
      }}
    />
  )
}

export default StructuredSearchData
